import { useQuery } from '@tanstack/react-query'
import { createApiCall } from 'services'

export type InternalUser = {
  id: string
  email: string
  first_name: string | null
  last_name: string | null
  active: boolean
  role: {
    id: string
    name: string
  }
  workos_user_id: string | null
  created_at: string
  updated_at: string | null
  deleted_at: string | null
}

export type GetInternalUsersParams = {
  limit?: number
  offset?: number
}

type GetInternalUsersResponse = {
  data: InternalUser[]
  total: number
}

export const INTERNAL_USERS_QUERY_KEY = 'internal-users'

export const useInternalUsers = (params?: GetInternalUsersParams) => {
  return useQuery<GetInternalUsersResponse>({
    queryKey: [INTERNAL_USERS_QUERY_KEY, params],
    queryFn: async () => {
      const response = await createApiCall({
        method: 'GET',
        url: '/admins/admin/platform-supervisors',
        params,
      })

      return response.data as GetInternalUsersResponse
    },
    staleTime: 1000 * 60, // 1 minute
  })
}
